import view from './view.js';
import reducer from './reducer.js';

export {view,reducer};


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/index.js